/**
 * useSelectedScale — ekran ayarlarında seçili tartıyı çözer
 *
 * Ekran ayarında yalnızca `SelectedScaleId` duruyor; cihaza bağlanmak için
 * IP/port/model gerekiyor ve bunlar `Scales` tablosunda. Bu hook o kaydı bir
 * kez çeker ve local-service'e verilecek hedefe çevirir.
 *
 * "Tartı kullan" kapalıysa istek hiç yapılmaz.
 */

import { useEffect, useState } from 'react';
import scaleApi, { ScaleDto } from '../services/scaleService';
import { ScaleTarget } from '../services/localScaleService';

export interface UseSelectedScaleResult {
  scale: ScaleDto | null;
  /** local-service'e verilecek hedef; tartı yoksa null. */
  target: ScaleTarget | null;
  loading: boolean;
}

export function useSelectedScale(
  useScale: boolean | undefined,
  selectedScaleId: number | null | undefined
): UseSelectedScaleResult {
  const [scale, setScale] = useState<ScaleDto | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!useScale || !selectedScaleId) {
      setScale(null);
      return;
    }

    let cancelled = false;
    setLoading(true);

    scaleApi
      .getById(selectedScaleId)
      .then((found) => {
        if (cancelled) return;
        // Pasife alınmış tartıya bağlanmayı denemeyelim
        setScale(found && found.isActive ? found : null);
      })
      .catch(() => {
        if (!cancelled) setScale(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [useScale, selectedScaleId]);

  return {
    scale,
    target: scale ? { host: scale.host, port: scale.port, model: scale.model } : null,
    loading,
  };
}

export default useSelectedScale;
